import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";
import { logger } from "../utils/logger";

export const getNotes = async (NotebookId, BoxId) => {
	try {
		const response = await axiosRequestInterceptor.get(
			`/notes/getNotes/${NotebookId}/${BoxId}`
		);
		logger.log("Response from getNotes: ", response?.data?.data?.NOTES);
		return { data: response?.data?.data?.NOTES };
	} catch (error) {
		return { error: error.response.data.error, data: { NOTES: [] } };
	}
};

export const saveNote = async (NotebookId, BoxId, Note) => {
	try {
		const response = await axiosRequestInterceptor.post(`/notes/saveNotes`, {
			NOTEBOOK_ID: NotebookId,
			BOX_ID: BoxId,
			NOTE: Note,
		});
		return { data: response?.data };
	} catch (error) {
		return { error: error.response.data.error };
	}
};

export const deleteNote = async (NotebookId, BoxId, NoteId) => {
	try {
		const response = await axiosRequestInterceptor.post(`/notes/deleteNotes/`, {
			NOTEBOOK_ID: NotebookId,
			BOX_ID: BoxId,
			NOTE_ID: NoteId,
		});
		return { data: response?.data?.data };
	} catch (error) {
		return { error: error.response.data.error };
	}
};

export const editNotes = async (NotebookId, BoxId, NoteId, Note) => {
	try {
		const response = await axiosRequestInterceptor.post(`/notes/editNotes/`, {
			NOTEBOOK_ID: NotebookId,
			BOX_ID: BoxId,
			NOTE_ID: NoteId,
			NOTE: Note,
		});
		return { data: response?.data?.data };
	} catch (error) {
		return { error: error.response.data.error };
	}
};
